interface DataDogLogger {
  debug(message: string, context?: object | undefined): void;
  error(message: string, context?: object | undefined): void;
  info(message: string, context?: object | undefined): void;
  log(message: string, context?: object | undefined, status?: 'error' | 'debug' | 'info' | 'warn' | undefined): void;
  warn(message: string, context?: object | undefined): void;
}

export default class ErrorLogger {
  static captureException(error: Error, message?: string): void {
    // TODO: when exceptions are caught, they should also automatically provide additional info - a unique error token for user+timestamp
    // This should be generated on the backend and provided to DataDog etc so that we can track errors across services.

    let errorMessage = error.message;
    if (message) {
      errorMessage = message + ': ' + errorMessage;
    }
    errorMessage = errorMessage || 'Unknown error';

    const dataDogLogger = this._getDataDogLogger();
    if (dataDogLogger) {
      try {
        this._getDataDogLogger().error(errorMessage, error);
      } catch (datadogError) {
        console.error('Failed to log to datadog: ', datadogError);
      }
    } else {
      console.error(error);
    }
  }

  private static _getDataDogLogger(): DataDogLogger {
    // initialised in the MVC app
    // TODO: remove eslint-disable-next-line
    // eslint-disable-next-line
    return (window as any).DD_LOGS?.logger;
  }
}
